export default "__VITE_ASSET__BOYg3vka__"